import React, { useEffect, useState } from 'react';
import { View, Switch, Text } from 'react-native';
import Theme from 'Theme';
import Hr from '../Hr';

import defaultStyles from './LabeledSwitch.jss';

type LabeledSwitch = {
    label: string;
    onValueChange: (value: boolean) => void;
    value: boolean;
    testID?: string;
};

const LabeledSwitch = ({ value, label, onValueChange, testID }: LabeledSwitch): JSX.Element => {
    const [isEnabled, setIsEnabled] = useState(value);
    const toggleSwitch = () => {
        setIsEnabled((previousState) => !previousState);
        onValueChange(!value);
    };

    return (
        <View key={label} style={defaultStyles.container}>
            <Hr />
            <View style={defaultStyles.switchWrapper}>
                <Text style={defaultStyles.label} numberOfLines={2}>
                    {label}
                </Text>
                <Switch
                    testID={testID}
                    value={isEnabled}
                    onValueChange={toggleSwitch}
                    trackColor={{
                        true: Theme.switchTrueColor,
                        false: Theme.switchFalseColor
                    }}
                    ios_backgroundColor="default"
                    thumbColor="#FFFF"
                    tintColor={Theme.switchFalseColor}
                />
            </View>
        </View>
    );
};

export default LabeledSwitch;
